import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'

import { Flex, Heading, SimpleGrid } from '@chakra-ui/react'

import { authSelector } from '@/stores/auth/authSlice'

import moment from 'moment'
//Api
import { ANNOUNCEMENT_TYPES } from '@/features/announcements/announcement.constant'
import useAnnouncement from '@/features/announcements/useAnnouncement'
import { ContributorGroupType } from '@/features/contributorGroups/constants'
import { showModal } from '@/stores/ui/modalSlice'
import { MODAL_TYPES } from '@/utils/constants/modalTypes'
import MyCostBudgetWidget from './components/MyCostBudgetWidget'
import MyProfileWidget from './components/MyProfileWidget'
import OfferApprovalTaskWidget from './components/OfferApprovalTaskWidget'
import OfferMaintenanceTaskWidget from './components/OfferMaintenanceTaskWidget'
import OfferParticipationTaskWidget from './components/OfferParticipationTaskWidget'
import OfferProjectTaskWidget from './components/OfferProjectTaskWidget'
import useOfferList from '../../hooks/useOfferList'
import { MyOfferDisplayLevel } from '@/features/tableProfiles/constants/tableProfile.constant'
import { OfferQuotationStatus, OfferStage, OfferType } from '@eapproval/offer-shared'
import MySourcingWidget from './components/MySourcingWidget'
import ProcurementSolutionWidget from './components/ProcurementSolutionWidget'
import ProcurementMaintenanceWidget from './components/ProcurementMaintenanceWidget'
import MyPRApprovalWidget from './components/MyPRApprovalWidget'
import MyGCPRApprovalWidget from './components/MyGCPRApprovalWidget'
import MyGCPRMaterialWidget from './components/MyGCPRMaterialWidget'

const OfferTaskDashboard = () => {
  const { user } = useSelector(authSelector)
  const dispatch = useDispatch()

  const navigate = useNavigate()
  const { useFetchMyOffers, useFetchMaintenanceSummary } = useOfferList()

  const { data: allOfferResponse } = useFetchMyOffers(
    {
      page: 1,
      pageSize: 0,
      filters: {
        salesResponsible: user?.fullName || '',
      },
    },
    MyOfferDisplayLevel.OFFER
  )

  const { useFetchAnnouncementByType } = useAnnouncement()

  const { data: fetchAnnouncementResponse } = useFetchAnnouncementByType(ANNOUNCEMENT_TYPES.INTERNAL)
  const announcementData = fetchAnnouncementResponse?.data

  useEffect(() => {
    // if (!announcementData || user.email.includes('@siemens.com')) return
    if (!announcementData) return

    const today = moment()
    const isTodayBetweenPeriod =
      announcementData?.startDate &&
      announcementData?.endDate &&
      today.isSameOrAfter(moment(announcementData?.startDate), 'day') &&
      today.isSameOrBefore(moment(announcementData?.endDate), 'day')

    if (!isTodayBetweenPeriod) return

    // Check if announcement was already shown in this session
    const announcementKey = `announcement_shown_${announcementData._id}`

    const hasBeenShown = sessionStorage.getItem(announcementKey)

    if (hasBeenShown) return

    // Mark as shown and display the modal
    sessionStorage.setItem(announcementKey, 'true')

    dispatch(
      showModal({
        modalType: MODAL_TYPES.ANNOUNCEMENT,
        modalProps: {
          contentHtml: announcementData?.contentHtml,
        },
      })
    )
  }, [announcementData, user, dispatch])

  const handleGotoOffer = (row) => {
    if (!row?.original?._id) return

    navigate(`/offers/${row?.original?._id}`)
  }
  return (
    <Flex bg="white" w="100%" h="100%" p={[2, 4]} direction={'column'}>
      <Flex p={[3, 5]} borderBottom="1px solid #d8dbe0">
        <Heading fontSize={['2xl', '3xl']}>My Tasks</Heading>
      </Flex>
      <Flex gap={[4, 5]} my={[4, 5]} direction={['column', null, 'row']} align={['stretch', null, 'flex-start']}>
        <SimpleGrid columns={[1, 1, 2]} spacingX="15px" spacingY="20px" w={['100%', null, '70%']}>
          <OfferApprovalTaskWidget />

          <MyPRApprovalWidget />
          <MyGCPRApprovalWidget />
          {/* <MyGCPRMaterialWidget /> */}

          {/* <OfferParticipationTaskWidget /> */}

          <OfferProjectTaskWidget
            quotationOffers={allOfferResponse?.data.filter(
              (offer) =>
                offer.mainSubSystemType === OfferType.PROJECT &&
                Object.values(OfferQuotationStatus).includes(offer.status)
            )}
            bookingOffers={allOfferResponse?.data.filter(
              (offer) => offer.mainSubSystemType === OfferType.PROJECT && offer.offerStage === OfferStage.BOOKING
            )}
          />

          <OfferMaintenanceTaskWidget
            quotationOffers={allOfferResponse?.data.filter(
              (offer) =>
                offer.mainSubSystemType === OfferType.MAINTENANCE &&
                Object.values(OfferQuotationStatus).includes(offer.status)
            )}
            bookingOffers={allOfferResponse?.data.filter(
              (offer) => offer.mainSubSystemType === OfferType.MAINTENANCE && offer.offerStage === OfferStage.BOOKING
            )}
          />

          {(user.contributorGroup === ContributorGroupType.PROCUREMENT_OFFICER || user.role === 'admin') && (
            <>
              <MyCostBudgetWidget />
              {/* <ProcurementMaintenanceWidget /> */}
              {/* <ProcurementSolutionWidget /> */}
            </>
          )}
        </SimpleGrid>

        {user.contributorGroup !== ContributorGroupType.PROCUREMENT_OFFICER && (
          <Flex w={['100%', null, '30%']}>
            <MyProfileWidget />
          </Flex>
        )}
        {user.contributorGroup === ContributorGroupType.PROCUREMENT_OFFICER && (
          <Flex w={['100%', null, '30%']}>
            <MySourcingWidget />
          </Flex>
        )}
      </Flex>
    </Flex>
  )
}

export default OfferTaskDashboard
